import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';
import { ChunkLoadErrorBoundary } from '@trello/error-reporting';
import type { BoardFacepileProps } from './BoardFacepile';

export const LazyBoardFacepile: FunctionComponent<BoardFacepileProps> = (
  props,
) => {
  const BoardFacepile = useLazyComponent(
    () => import(/* webpackChunkName: "board-facepile" */ './BoardFacepile'),
    { namedImport: 'BoardFacepile' },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <BoardFacepile {...props} />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
